import useJourneyContext from "./useJourneyContext";
const useTSILeg = (legId) => {
  var _a;
  const { tsiJourney } = useJourneyContext();
  if (typeof tsiJourney === "undefined") {
    return void 0;
  }
  return (_a = Object.entries(tsiJourney.legIdToTSILeg).find(([k]) => k === legId)) == null ? void 0 : _a[1];
};
var useTSILeg_default = useTSILeg;
export {
  useTSILeg_default as default
};
